//Categorias y niveles
const categorias = [
    "Infantil 4 a 8 años",
    "Infantil 8 a 12 años",
    "Juvenil 12 a 18 años",
    "Adultos"
]
const niveles = [
    "Etapa roja",
    "Etapa naranja",
    "Etapa verde",
    "Clase D",
    "Clase C",
    "Clase B",
    "Clase A",
    "Profesional"
]

const dias = [
    "Lunes",
    "Martes",
    "Miercoles",
    "Jueves",
    "Viernes",
    "Sabado",
    "Domingo"
]

// Array de horas con slots de 30 minutos (48 slots total: 24 horas * 2)
// Cada índice representa un slot de 30 minutos
// Índice 0 = 01:00, Índice 1 = 01:30, Índice 2 = 02:00, etc.
const horas = [
    "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30",
    "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30",
    "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30",
    "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30",
    "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30",
    "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "24:00", "24:30"
]

export {
    categorias,
    niveles,
    dias,
    horas
}